<template>
  <div id='projectBar' class='subHeader blue darken-4'>
    <v-row no-gutters justify='center' class="mt-1">
      <v-col cols="8" class="sc-pr-parent">
        <div class="sc-pr-element">
          <FontIcon class="pr-4 pointer" @click.native="goHome" color=#FFF>arrow_back</FontIcon>
          {{projectName || ''}}
        </div>
        <div class="sc-pr-element country">
          {{projectCountry || ''}}
        </div>
        <div class="sc-pr-element center">
          {{scenarioName || ''}}
        </div>
        <div class="sc-pr-element date">
         {{projectDate || ''}}
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script lang='ts'>
import { Component, Vue } from 'vue-property-decorator';
import { ProjectMeta } from '@/classes/ProjectMeta';
import _t from '@/helpers/timeHelper';
import { ScenarioExt } from '@/classes/scenario/ScenarioExt';
import FontIcon from '@/components/FontIcon.vue';

@Component({
  components: {
    FontIcon
  }
})
export default class ScenarioProjectHeader extends Vue {
  private goHome() {
    this.$router.push('/');
  }
  get projectData(): ProjectMeta | null {
    return this.$store.getters['project/getCurrentProject'];
  }
  get projectName(): string | undefined | null {
    return this.projectData && this.projectData.name;
  }
  get projectCountry(): string | undefined | null {
    return this.projectData && this.projectData.country;
  }
  get projectDate() {
    return this.projectData && this.projectData.startDate ? _t.formatDate(_t.getDate(this.projectData.startDate), 'll') : '';
  }
  get scenario(): ScenarioExt {
    return this.$store.getters['scenario/getFields'];
  }
  get scenarioName(): string | undefined | null {
    return this.scenario && this.scenario.name;
  }

}
</script>

<style lang='stylus'>
.subHeader {
  position: fixed;
  left: 0px;
  width: 100%;
  height: 40px;
  z-index: 4;
  top: 100px;
  color: white;
}

.sc-pr-parent {
  display flex;
}
.sc-pr-element {
  flex: 2;
  align-content: center;
  justify-content: space-around;
  font-size: 14px;
  line-height: 2rem;
  max-height: 2rem;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  &.country {
    flex: 1;
    opacity: 0.5;
  }
  &.date {
    text-align: right;
    opacity: 0.5;
  }
  &.center {
    text-align: center;
  }
}
.pointer {
  cursor: pointer;
}
</style>
